import { Box, Flex } from "@chakra-ui/react";
import InfoBaloon from "../../../assets/icons/alert-message-white.svg";
import { MilestoneBadge } from "./MilestoneBadge";
import { dateFromMs } from "../../api/utils";
import { renderToHTML } from "common/src/markdown";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MilestoneUpdate = _ref => {
  let {
    createdAtMs,
    text
  } = _ref;
  return /*#__PURE__*/_jsxs(Box, {
    p: 4,
    ml: 5,
    className: "bg-gitcoin-violet-100",
    borderRadius: "md",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      mb: 5,
      children: [/*#__PURE__*/_jsx(MilestoneBadge, {
        icon: InfoBaloon,
        title: "Update",
        classNames: "bg-gitcoin-violet-500 text-white"
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsxs("small", {
          children: ["Posted on ", dateFromMs(createdAtMs)]
        })
      })]
    }), text ? /*#__PURE__*/_jsx(Box, {
      __css: {
        h1: {
          fontSize: "1.5rem",
          fontWeight: "bold",
          margin: "1rem 0"
        },
        h2: {
          fontSize: "1.25rem",
          fontWeight: "bold",
          margin: "1rem 0"
        }
      },
      dangerouslySetInnerHTML: {
        __html: renderToHTML(text)
      }
    }) : "No update text provided"]
  });
};